// ─── Rank & Level System ──────────────────────────────────────────────────────
// 60 defined levels total. Every level costs 750 XP (Bronze levels cost 500 XP).
// Grandmaster continues infinitely at 750 XP / level past Lv 50.
//
// RANK DISTRIBUTION:
//   Bronze I–III    Lv  1– 3  (500 XP each)
//   Silver I–III    Lv  4– 6  (750 XP each)
//   Gold   I–III    Lv  7–12  (2 levels per tier, 750 XP each)
//   Platinum I–III  Lv 13–18  (2 levels per tier, 750 XP each)
//   Diamond  I–III  Lv 19–27  (3 levels per tier, 750 XP each)
//   Ascendant I–III Lv 28–37  (3/3/4 levels per tier, 750 XP each)
//   Master   I–III  Lv 38–49  (4 levels per tier, 750 XP each)
//   Grandmaster     Lv 50+    (750 XP per level, infinite)

export const RANK_COLORS = {
  Bronze:      '#cd7f32',
  Silver:      '#a8b2bd',
  Gold:        '#c9940a',
  Platinum:    '#4fc4cf',
  Diamond:     '#4a90e2',
  Ascendant:   '#3dd68c',
  Master:      '#8b1a2f',
  Grandmaster: '#ff4655',
};

// Each entry: { level, rank, tier, minXp }
// xpPerLevel = next entry's minXp - this entry's minXp  (or GM_XP_PER_LEVEL for GM)
export const LEVELS = [
  // Bronze
  { level:  1, rank: 'Bronze',      tier: 1, minXp:     0 },
  { level:  2, rank: 'Bronze',      tier: 2, minXp:   500 },
  { level:  3, rank: 'Bronze',      tier: 3, minXp:  1000 },
  // Silver
  { level:  4, rank: 'Silver',      tier: 1, minXp:  1500 },
  { level:  5, rank: 'Silver',      tier: 2, minXp:  2250 },
  { level:  6, rank: 'Silver',      tier: 3, minXp:  3000 },
  // Gold I (2 levels)
  { level:  7, rank: 'Gold',        tier: 1, minXp:  3750 },
  { level:  8, rank: 'Gold',        tier: 1, minXp:  4500 },
  // Gold II (2 levels)
  { level:  9, rank: 'Gold',        tier: 2, minXp:  5250 },
  { level: 10, rank: 'Gold',        tier: 2, minXp:  6000 },
  // Gold III (2 levels)
  { level: 11, rank: 'Gold',        tier: 3, minXp:  6750 },
  { level: 12, rank: 'Gold',        tier: 3, minXp:  7500 },
  // Platinum I (2 levels)
  { level: 13, rank: 'Platinum',    tier: 1, minXp:  8250 },
  { level: 14, rank: 'Platinum',    tier: 1, minXp:  9000 },
  // Platinum II (2 levels)
  { level: 15, rank: 'Platinum',    tier: 2, minXp:  9750 },
  { level: 16, rank: 'Platinum',    tier: 2, minXp: 10500 },
  // Platinum III (2 levels)
  { level: 17, rank: 'Platinum',    tier: 3, minXp: 11250 },
  { level: 18, rank: 'Platinum',    tier: 3, minXp: 12000 },
  // Diamond I (3 levels)
  { level: 19, rank: 'Diamond',     tier: 1, minXp: 12750 },
  { level: 20, rank: 'Diamond',     tier: 1, minXp: 13500 },
  { level: 21, rank: 'Diamond',     tier: 1, minXp: 14250 },
  // Diamond II (3 levels)
  { level: 22, rank: 'Diamond',     tier: 2, minXp: 15000 },
  { level: 23, rank: 'Diamond',     tier: 2, minXp: 15750 },
  { level: 24, rank: 'Diamond',     tier: 2, minXp: 16500 },
  // Diamond III (3 levels)
  { level: 25, rank: 'Diamond',     tier: 3, minXp: 17250 },
  { level: 26, rank: 'Diamond',     tier: 3, minXp: 18000 },
  { level: 27, rank: 'Diamond',     tier: 3, minXp: 18750 },
  // Ascendant I (3 levels)
  { level: 28, rank: 'Ascendant',   tier: 1, minXp: 19500 },
  { level: 29, rank: 'Ascendant',   tier: 1, minXp: 20250 },
  { level: 30, rank: 'Ascendant',   tier: 1, minXp: 21000 },
  // Ascendant II (3 levels)
  { level: 31, rank: 'Ascendant',   tier: 2, minXp: 21750 },
  { level: 32, rank: 'Ascendant',   tier: 2, minXp: 22500 },
  { level: 33, rank: 'Ascendant',   tier: 2, minXp: 23250 },
  // Ascendant III (4 levels)
  { level: 34, rank: 'Ascendant',   tier: 3, minXp: 24000 },
  { level: 35, rank: 'Ascendant',   tier: 3, minXp: 24750 },
  { level: 36, rank: 'Ascendant',   tier: 3, minXp: 25500 },
  { level: 37, rank: 'Ascendant',   tier: 3, minXp: 26250 },
  // Master I (4 levels)
  { level: 38, rank: 'Master',      tier: 1, minXp: 27000 },
  { level: 39, rank: 'Master',      tier: 1, minXp: 27750 },
  { level: 40, rank: 'Master',      tier: 1, minXp: 28500 },
  { level: 41, rank: 'Master',      tier: 1, minXp: 29250 },
  // Master II (4 levels)
  { level: 42, rank: 'Master',      tier: 2, minXp: 30000 },
  { level: 43, rank: 'Master',      tier: 2, minXp: 30750 },
  { level: 44, rank: 'Master',      tier: 2, minXp: 31500 },
  { level: 45, rank: 'Master',      tier: 2, minXp: 32250 },
  // Master III (4 levels)
  { level: 46, rank: 'Master',      tier: 3, minXp: 33000 },
  { level: 47, rank: 'Master',      tier: 3, minXp: 33750 },
  { level: 48, rank: 'Master',      tier: 3, minXp: 34500 },
  { level: 49, rank: 'Master',      tier: 3, minXp: 35250 },
  // Grandmaster (infinite levels at 750 XP each, starting Lv 50)
  { level: 50, rank: 'Grandmaster', tier: 1, minXp: 36000 },
];

const GM_MIN_XP      = 36000;
const GM_XP_PER_LEVEL = 750;
const GM_BASE_LEVEL  = 50;

// Roman numerals for display
const ROMAN = ['I','II','III'];

function tierStr(tier) {
  return ROMAN[Math.min(tier - 1, ROMAN.length - 1)] ?? String(tier);
}

function rankIcon(rank, tier) {
  if (rank === 'Grandmaster') return '/ranks/Grandmaster_Rank.png';
  return `/ranks/${rank}_${tier}_Rank.png`;
}

// ─── Core: getRankInfo(xp) ────────────────────────────────────────────────────
// Returns everything callers need about a player's current standing.
export function getRankInfo(xp) {
  const totalXp = Math.max(0, xp ?? 0);

  // Grandmaster: infinite levels at 750 XP each
  if (totalXp >= GM_MIN_XP) {
    const levelsGained  = Math.floor((totalXp - GM_MIN_XP) / GM_XP_PER_LEVEL);
    const level         = GM_BASE_LEVEL + levelsGained;
    const minXp         = GM_MIN_XP + levelsGained * GM_XP_PER_LEVEL;
    const xpIntoLevel   = totalXp - minXp;
    const gmTierLabel   = level <= 53
      ? `Grandmaster ${tierStr(levelsGained + 1)}`
      : `Grandmaster ${level}`;
    return {
      name:          'Grandmaster',
      tier:          levelsGained + 1,
      level,
      label:         gmTierLabel,
      rankLabel:     'Grandmaster',
      icon:          '/ranks/Grandmaster_Rank.png',
      color:         RANK_COLORS.Grandmaster,
      minXp,
      xpPerLevel:    GM_XP_PER_LEVEL,
      xpToNext:      GM_XP_PER_LEVEL,
      xpIntoLevel,
      totalXp,
      isGrandmaster: true,
    };
  }

  // Find highest reached level entry
  let def = LEVELS[0];
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (totalXp >= LEVELS[i].minXp) { def = LEVELS[i]; break; }
  }

  // xpToNext = gap to next level (or to GM entry if last pre-GM level)
  const nextEntry  = LEVELS.find(l => l.level === def.level + 1);
  const nextMinXp  = nextEntry ? nextEntry.minXp : GM_MIN_XP;
  const xpToNext   = nextMinXp - def.minXp;
  const xpIntoLevel = totalXp - def.minXp;
  const label = `${def.rank} ${tierStr(def.tier)}`;

  return {
    name:          def.rank,
    tier:          def.tier,
    level:         def.level,
    label,
    rankLabel:     label,
    icon:          rankIcon(def.rank, def.tier),
    color:         RANK_COLORS[def.rank],
    minXp:         def.minXp,
    xpPerLevel:    xpToNext,
    xpToNext,
    xpIntoLevel,
    totalXp,
    isGrandmaster: false,
  };
}

// ─── Rank-span bounds (for progress bar) ──────────────────────────────────────
// Returns the XP range of the entire current rank tier (e.g., Gold I = Lv 7–8)
// plus internal level-boundary XP values (for tick marks) and neighboring rank info.
export function getTierBounds(xp) {
  const info    = getRankInfo(xp);
  const totalXp = Math.max(0, xp ?? 0);

  if (info.isGrandmaster) {
    // For GM, treat the progress bar as the single current level (750 XP span)
    return {
      currentMin:       info.minXp,
      nextMin:          info.minXp + GM_XP_PER_LEVEL,
      levelTicks:       [],            // no internal ticks — single level
      levelsInRank:     1,
      currentRankInfo:  info,
      nextRankInfo:     getRankInfo(info.minXp + GM_XP_PER_LEVEL),
    };
  }

  // Collect all levels that share the same rank+tier
  const tierLevels = LEVELS.filter(l => l.rank === info.name && l.tier === info.tier);
  const firstLevel = tierLevels[0];
  const lastLevel  = tierLevels[tierLevels.length - 1];

  // Next rank's entry XP
  const nextEntry  = LEVELS.find(l => l.level === lastLevel.level + 1);
  const nextMin    = nextEntry ? nextEntry.minXp : GM_MIN_XP;

  // Internal tick positions: XP of each level boundary WITHIN this tier
  // (excludes the start and the end, which are the rank endpoints)
  const levelTicks = tierLevels.slice(1).map(l => l.minXp);

  return {
    currentMin:      firstLevel.minXp,
    nextMin,
    levelTicks,                          // e.g. for Gold I (Lv 7–8): [4500]
    levelsInRank:    tierLevels.length,
    currentRankInfo: info,
    nextRankInfo:    getRankInfo(nextMin),
  };
}

// ─── Convenience helpers ──────────────────────────────────────────────────────

export function xpToNextLevel(xp) {
  const info = getRankInfo(Math.max(0, xp ?? 0));
  return info.xpToNext - info.xpIntoLevel;
}

// Legacy alias
export const eloToNextTier = xpToNextLevel;
export const xpToNextTier  = xpToNextLevel;

// Platinum I starts at Lv 13, minXp = 8250
// Used by server-side rank tier determination
export const PLATINUM_MIN_XP = 8250;
